// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"00ea4ab0fcf0af8f","6831":"fbd47e1903b8c757","8503":"d8165efcfe501d13","9683":"79586cd790eecde0"}[chunkId] + ".js";
};